import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface InputDriver extends BaseUniDriver {}

export const inputDriverFactory = (base: UniDriver): InputDriver => {
  return {
    ...baseUniDriverFactory(base),
    // TODO - migrate to unidriver
  };
};
